<template>
    <div class="massDetail" v-if="msgDetail.recipient">
        <span class="btn-close" @click="handleClose"><svg-icon icon-class="close"></svg-icon></span>
        <div class="module-item-title">详情</div>
        <div style="padding: 0 15px;box-sizing: border-box;">
            <div class="detail-item">
                <div class="detail-label">访客来源：</div>
                <div class="detail-content">{{msgDetail.sourceQk}}</div>
            </div>
            <div class="detail-item">
                <div class="detail-label">群发时间：</div>
                <div class="detail-content">{{ $utils.timestampToTime(msgDetail.sendTime)}}</div>
            </div>
            <div class="detail-item">
                <div class="detail-label">收件访客：</div>
                <div class="detail-content">{{msgDetail.recipient.substr(1)}}</div>
            </div>
            <div class="detail-item">
                <div class="detail-label">消息内容：</div>
                <div class="detail-content"><div v-html="formatTrendEmoji(msgDetail.textContent)"></div> <br /><img v-if="msgDetail.imgContent.length > 0" :src="msgDetail.imgContent" alt="" style="max-width: 60%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import emojiData from '@/libs/emoji/emoji-data'
    export default {
        props:['msgDetail'],
        name: "massDetail",
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        methods: {
            /**
             * 【点击展开/关闭右侧】
             */
            handleClose() {
                this.$emit('closePanel')
            },
            formatTrendEmoji(val) {
                let s_name = val;
                let s_img = [];
                let rules = /:([^:][a-z_\-]+):/g
                s_name.replace(rules, function ($1, $2) {
                    s_img.push($2);
                })
                for (let i = 0; i < s_img.length; i++) {
                    let str = ''
                    let r_str = ':' + s_img[i] + ':'
                    for (let key in emojiData) {
                        if (s_img[i] == key) {
                            let imgPath = require(`@/libs/emoji/images/${s_img[i]}.gif`)
                            str = s_name.replace(r_str, `<img style="display: inline-block;max-width: 24px;max-height: 24px;" src="` + imgPath + `" class="img">`)
                        } else {
                            str = s_name.replace(r_str, r_str)
                        }
                        s_name = str
                    }
                }
                return s_name
            },
        }
    }
</script>

<style lang="scss">
    .massDetail {
        position: relative;
        padding: 30px;
        box-sizing: border-box;
        .detail-item{
            padding: 15px 0;
            box-sizing: border-box;
            display: flex;
            .detail-label{
                width: 80px;
            }
            .detail-content{
                flex: 1;
                word-break: break-all;
            }
        }
        .btn-close {
            position: absolute;
            display: inline-block;
            left: 0;
            height: 36px;
            width: 18px;
            line-height: 32px;
            z-index: 1;
            border-radius: 18px 0 0 18px;
            box-sizing: border-box;
            text-align: right;
            color: #bbb;
            border-top: 1px solid #cccccd;
            border-bottom: 1px solid #cccccd;
            border-left: 1px solid #cccccd;
            margin-left: -18px;
            margin-top: 6px;
            background: #F5F6F7;
            cursor: pointer;

            .svg-icon {
                margin-left: 7px;
            }
        }
    }
</style>